// extracted by mini-css-extract-plugin
module.exports = {"root":"_2scDY","stripped":"qG91M","truncated":"_6ph2U"};